import * as React from 'react';
import { BoxProps as BoxPropsMUI } from '@material-ui/core/Box';

import { MediaRules } from '../../styles';
import { Root } from './styled';


export type BoxProps = {
	margin?: number | string;
	padding?: number | string;
	textTransform?: 'uppercase' | 'none';
	mediaRules?: MediaRules;
} & Omit<BoxPropsMUI, 'margin' | 'padding'>

const Box: React.SFC<BoxProps> = (props) => {

	return (
		<Root {...props} />
	);
}

Box.displayName = 'Box';
Box.defaultProps = {
	textTransform: 'none'
};

export default Box;
